import type { PropsWithChildren, FC } from 'react'
import { useNavHierarchyAdmin } from '../../NavMenuHierarchy'
import { LeftShortcutsPane } from './LeftShortcutsPane'

export const LeftShortcutsPaneAdmin: FC<PropsWithChildren<unknown>> = () => {
  const { indexedL1ByRoutes } = useNavHierarchyAdmin()

  return <LeftShortcutsPane indexedL1ByRoutes={indexedL1ByRoutes} />
}
